import { formatDate, getTimezoneAbbreviation } from '../../utils/date';
import { useDatePreferences } from '../hooks/useDatePreferences';
import Text from './base/Text';
import type { StyledUtilsProps } from './helpers/StyledUtils';

interface DisplayDateProps extends StyledUtilsProps {
  date: string | null;
  empty_string?: string;
  size?: 'xs' | 's' | 'm';
  show_timezone?: boolean;
}

const DisplayDate: React.FC<DisplayDateProps> = ({
  date,
  empty_string = '–',
  size = 's',
  show_timezone = true,
  ...props
}) => {
  const { timezone } = useDatePreferences();
  const text_date = date
    ? `${formatDate(date, 'yyyy-MM-dd HH:mm:ss', timezone)} ${
        show_timezone ? getTimezoneAbbreviation(timezone, date) : ''
      }`
    : empty_string;
  return (
    <Text mono size={size} muted as="p" m={{ b: 0 }} ellipsis title={text_date} {...props}>
      {text_date}
    </Text>
  );
};

export default DisplayDate;
